import * as yup from "yup";

// Validación para Representación Natural
export const naturalSchema = yup.object().shape({
  nombre: yup
    .string()
    .required("*Ingrese el nombre*")
    .min(3, "*El nombre debe tener al menos 3 caracteres*"),

  dni: yup.string().required("*Ingrese el DNI*"),

  depto: yup.string().required("*Seleccione un Departamento*"),

  municipio: yup.string().required("*Seleccione un Municipio*"),

  colonia: yup
    .string()
    .required("*Ingrese la colonia*")
    .max(50, "*La colonia no debe exceder los 50 caracteres*"),

  celular: yup
    .string()
    .matches(/^\d{8}$/, "*El celular debe contener exactamente 8 dígitos*")
    .required("*Ingrese el celular*"),

  correo: yup
    .string()
    .email("*Ingrese un correo válido*")
    .required("*Ingrese el correo*"),
});

// Validación para Representación Jurídica
export const juridicaSchema = yup.object().shape({
  razonSocial: yup
    .string()
    .required("*Ingrese su razón social*")
    .min(3, "*La razón social debe tener al menos 3 caracteres*")
    .max(100, "*La razón social no debe exceder los 100 caracteres*"),

  dni: yup.string().required("*Ingrese su DNI*"),

  depto: yup
    .string()
    .notOneOf(
      ["Seleccione un Departamento"],
      "*Seleccione un Departamento válido*",
    )
    .required("*Seleccione un Departamento*"),

  municipio: yup
    .string()
    .notOneOf(["Seleccione un Municipio"], "*Seleccione un Municipio válido*")
    .required("*Seleccione un Municipio*"),

  domicilio: yup
    .string()
    .required("*Ingrese su domicilio*")
    .max(150, "*El domicilio no debe exceder los 150 caracteres*"),

  telefono: yup
    .string()
    .matches(/^\d{8}$/, "*El teléfono debe contener exactamente 8 dígitos*")
    .required("*Ingrese su teléfono*"),

  correo: yup
    .string()
    .email("*Ingrese un correo válido*")
    .required("*Ingrese su correo*"),

  apoderado: yup
    .string()
    .required("*Ingrese el nombre del apoderado*")
    .min(3, "*El nombre del apoderado debe tener al menos 3 caracteres*")
    .max(50, "*El nombre del apoderado no debe exceder los 50 caracteres*"),
});
